import script from "./Breakpoints.vue?vue&type=script&lang=ts"
export * from "./Breakpoints.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__